<script>
import { Select } from 'element-ui';
// import { LibsThrottler } from '@/libs/LibsThrottler';

/** 自定义下拉组件 继承自 el-select */
export default {
	name: 'CustomSelector',
	extends: Select,
	/** data */
	data() {
		return {
			// throttler: new LibsThrottler()
		};
	},

	/** hook */
	mounted() {
		// console.log('this.remoteMethod', this.remoteMethod);
	},

	methods: {
		// hole
	}
};
</script>
